import { useDynamicLocale } from '@/hoslog-intl';

import { useState } from 'react';
import type { DateRange } from 'react-day-picker';
import { AffiliateCustomerReferralTable } from '../table/affiliateCustomerReferral';
import { AffiliateNetworkReferralTable } from '../table/affiliateNetworkReferral';
import { useAffiliateReferralDetails } from './useAffiliateReferralDetails';
import { useCustomerReferralDetails } from './useCustomerReferralDetails';

export function useReferralDetailPage(reportType: string) {
  const { t } = useDynamicLocale();
  const [dateRange, setDateRange] = useState<DateRange | undefined>();
  const { customerReferralDetails, isLoading: isCustomerLoading, pagination } = useCustomerReferralDetails(dateRange);
  const {
    affiliateReferralDetails,
    isLoading: isAffiliateLoading,
    pagination: affiliateReferralPagination,
  } = useAffiliateReferralDetails(dateRange);
  const items = [
    {
      label: t('dashboard.referralReports.tabs.customer'),
      value: 'customer',
      content: (
        <AffiliateCustomerReferralTable
          data={customerReferralDetails}
          pagination={pagination}
          isLoading={isCustomerLoading}
        />
      ),
    },
    {
      label: t('dashboard.referralReports.tabs.affiliate'),
      value: 'affiliate',
      content: (
        <AffiliateNetworkReferralTable
          data={affiliateReferralDetails}
          pagination={affiliateReferralPagination}
          isLoading={isAffiliateLoading}
        />
      ),
    },
  ];
  return { dateRange, setDateRange, items, isCustomer: reportType === 'customer' };
}
